import React from "react"
import Header from "./components/header/Header"
import PdfProof from "./components/pdf-proof/PdfProof"
import "./App.css"
import {NewRelicSPA} from "@vp/react-new-relic-browser"

const App = () => {
	return (
		<div>
			<NewRelicSPA newRelicApplicationId={process.env.REACT_APP_NEW_RELIC_APPLICATION_ID} />
			<Header></Header>
			<PdfProof></PdfProof>
		</div>
	)
}

export default App
